import { LayerModule } from './.LayerModule';
import ApiLayersMap from '../WebApiModules/ApiLayersMap.js';

export class CustomEconomicDataLayerModule extends LayerModule {
    async OpenLayer(callback) {
        return new Promise((rs) => {
            ApiLayersMap.ListLayerInfo(
                { FolderFullName: this.layerInfo.FolderFullName, Name: this.layerInfo.Name },
                (obj) => {
                    console.log(obj);
                    let result = obj.result;
                    this.entityList = [];
                    this.colorList = [];
                    this.lines = [];
                    this.risingEntity = [];
                    this.stopAnimation = true;
                    this.get3DDate(result.ID,
                        (obj) => {
                            this.oviewLayer = this.getCustomLayer();
                            obj.result.forEach(result => {
                                let polygonset = new window.GeoPolygonSet();
                                polygonset.FromGeoJSON(result.Geo);
                                //console.log(polygonset.Bounds[0].SimplifyByPointCount(1000000));
                                let color = this.randomColor();

                                let param = {};
                                param.geo = polygonset;
                                param.height = 0;
                                param.surfaceHeight = 4000;
                                param.epsg = 3826;
                                param.color = color;
                                param.drawBorder = false;
                                param.borderColor = color;
                                let entity = this.oviewLayer.addPolygonPrismEntity(param);

                                let textParam = {};
                                textParam.geo = new window.GeoPoint(polygonset.Center.x, polygonset.Center.y, 4000 + 100 * result.count);
                                textParam.color = new window.ov.Color("#FFFFFF");
                                textParam.text = result.townName + "(" + result.count + "筆)";
                                textParam.size = 14;
                                textParam.borderColor = new window.ov.Color("#000000");
                                textParam.borderSize = 4;
                                textParam.epsg = 3826;

                                //this.oviewLayer.addTextEntity(textParam);

                                let points = [];
                                polygonset.Bounds[0].Buffer.forEach(point => {
                                    points.push(new window.GeoPoint(point.x, point.y, 4000));
                                });
                                let line = new window.GeoPolyline(points);
                                this.lines.push(line);

                                this.risingEntity.push({ entity: entity, textParam: textParam, count: result.count })
                                this.entityList.push({ geo: polygonset, townName: result.townName, count: result.count });
                            });
                            console.log(this.entityList);
                            this.risingAnimation();
                            let param = { success: obj.success, ID: result.ID + "(3D社會經濟地圖)" };
                            rs(param)
                        },
                        () => { console.error(`取得${this.layerInfo.FolderFullName}/${this.layerInfo.Name}圖層資訊失敗`) })
                },
                () => {
                    console.error(`取得${this.layerInfo.FolderFullName}/${this.layerInfo.Name}圖層資訊失敗`)
                }
            )
        }).then((param) => {
            console.log(param);
            if (param.message === "duplicate name exists") { // 如果只是名稱重複當作成功
                this.oviewLayer = window.gMainMap.TerrainView.findLayer(this.layerInfo.Name);
                param.success = true;
            }
            // 有參考的圖層到都加進去
            window.gMainMap.TerrainView.openedLayerStack.push(this.oviewLayer.name);
            callback && callback(param);
            return param.success;
        }, () => {
            return false;
        });
    }

    async get3DDate(ID, successCallback, errorCallback) {
        let url = window.gMainMap.MakeDoCmdUrl("CMD_GetStatisticsByTownArea");

        let data = { "counity": "南投縣", "town": "", "layername": ID };

        try {
            const response = await fetch(url, {
                method: "POST",
                headers: new Headers({
                    "Content-Type": "application/json",
                }),
                body: JSON.stringify(data)
            });
            const json = await response.json();

            if (json.success) {
                successCallback(json);
            }
            else {
                errorCallback(json);
            }
        } catch (error) {
            console.log("error:", error);
        }
    }

    randomColor() {
        let r, g, b;
        let isDuplicate = true;
        while (isDuplicate) {
            isDuplicate = false;

            r = Math.floor(Math.random() * 256);
            g = Math.floor(Math.random() * 256);
            b = Math.floor(Math.random() * 256);

            for (let i = 0; i < this.colorList.length; i++) {
                if (this.colorList.r === r && this.colorList.g === g && this.colorList.b === b) {
                    isDuplicate = true;
                    break;
                }
            }
        }

        let color = new window.ov.Color(r, g, b);
        this.colorList.push(color);

        return color;
    }

    repaint(list) {
        if (this.stopAnimation) {
            this.oviewLayer.removeAllEntity();

            this.entityList.forEach((result, index) => {
                let color = this.colorList[index]

                let param = {};
                let textParam = {};
                if (list.indexOf(result.townName) >= 0 && result.count > 0) {
                    param.geo = result.geo;
                    param.height = 100 * result.count;
                    param.surfaceHeight = 4000;
                    param.epsg = 3826;
                    param.color = color;
                    param.drawBorder = false;
                    this.oviewLayer.addPolygonPrismEntity(param);

                    textParam.geo = new window.GeoPoint(result.geo.Center.x, result.geo.Center.y, 4000 + 100 * result.count);
                    textParam.color = new window.ov.Color("#FFFFFF");
                    textParam.text = result.townName + "(" + result.count + "筆)";
                    textParam.size = 14;
                    textParam.borderColor = new window.ov.Color("#000000");
                    textParam.borderSize = 4;
                    textParam.epsg = 3826;
                }
                else {
                    param.geo = this.lines[index];
                    param.color = color;
                    param.size = 4;
                    param.epsg = 3826;
                    this.oviewLayer.addPolylineEntity(param);

                    textParam.geo = new window.GeoPoint(result.geo.Center.x, result.geo.Center.y, 4000);
                    textParam.color = new window.ov.Color("#FFFFFF");
                    textParam.text = result.townName + "(" + result.count + "筆)";
                    textParam.size = 14;
                    textParam.borderColor = new window.ov.Color("#000000");
                    textParam.borderSize = 4;
                    textParam.epsg = 3826;
                }

                this.oviewLayer.addTextEntity(textParam);
            });
        }
    }

    risingAnimation() {
        let timeset;
        timeset = setInterval(function () {
            let stop = true;
            this.risingEntity.forEach(entity => {
                let height = entity.entity.getParameter().height;
                if (!entity.entity || !this.oviewLayer) {
                    clearInterval(timeset);
                }

                if (height < 100 * entity.count) {
                    stop = false;
                    height += 100 * (entity.count / 10);
                    entity.entity.update({
                        height: height,
                    });
                }
            });

            if (stop) {
                this.risingEntity.forEach((entity, index) => {
                    if (this.oviewLayer) {
                        this.oviewLayer.addTextEntity(entity.textParam);

                        if (entity.count === 0) {
                            let param = {};
                            param.geo = this.lines[index];
                            param.color = this.colorList[index];
                            param.size = 4;
                            param.epsg = 3826;
                            this.oviewLayer.addPolylineEntity(param);
                        }
                    }
                });
                clearInterval(timeset);
                this.stopAnimation = true;
            }
        }.bind(this), 100);
    }

    getCustomLayer() {
        try {
            let layer = window.gMainMap.TerrainView.findLayer(this.layerInfo.Name);
            if (!layer) {
                layer = window.gMainMap.TerrainView.addCustomLayer(this.layerInfo.Name);
            }
            layer.setDepthTest(false);
            return layer;
        } catch (error) {
            return null;
        }
    }
}